namespace SPA
{
	export namespace Realtor2
	{
		export namespace New
		{

			interface ILNSResult
			{
				slider: ui.Form.LabelledNumberSlider;
				cy: ui.Form.NumberInput;
			}

			interface IModBoolResult
			{
				done: ui.Form.Checkbox;
				cy: ui.Form.NumberInput;
			}

			export class Modernization extends Guide.GuideContent
			{

				private m_Form: ui.Form.Form;

				public constructor( private m_Mod: IModernization, private m_Obj: Realtor2.NewObject )
				{
					super();

					this.m_Form = new ui.Form.Form(
						{
							action: '',
							method: 'POST',
							notSwitchable: true,
							submit: () => { return; }
						}
					);
				}

				public build( root: ui.base.BaseHTMLElement ): void
				{
					// #region basic
					{
						const _basicLeft = new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12' )
							.append(
								new ui.base.BaseHTMLElement( 'h4' )
									.text( 'Objektzustand' )
								.addClass( 'text-muted' )
							)
						.appendTo( root );
						const _basicRight = new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12 col-md-10 col-lg-8' )
							.append( new ui.base.BaseHTMLElement( 'h4' ).text( 'Bemerkung zum Objektzustand' ) )
						.appendTo( root );

						const basic_ind: ui.Form.RadioGroup = new ui.Form.RadioGroup(
							{
								radioButtons:
								[
									{
										title: 'Sehr gut',
										value: 'VERY_GOOD'
									},
									{
										title: 'Gut',
										value: 'GOOD'
									},
									{
										title: 'Befriedigend',
										value: 'SATISFYING'
									},
									{
										title: 'Ausreichend',
										value: 'SUFFICIENT'
									},
									{
										title: 'Mangelhaft',
										value: 'INADEQUAT'
									}
								],
								control: true,
								classes: ['iwv-req'],
								name: 'object.modernization.basic.value',
								on:
								{
									// @ts-ignore
									change: () => this.m_Mod.object_condition.value = basic_ind.val() || 'SATISFYING'
								},
								value: this.m_Mod.object_condition.value,
								inline: 5
							}
						);

						const basic_ann: ui.Form.TextArea = new ui.Form.TextArea(
							{
								text: this.m_Mod.object_condition.annotation,
								control: true,
								rows: 3,
								css:
								{
									resize: 'vertical'
								},
								on:
								{
									change: () => this.m_Mod.object_condition.annotation = basic_ann.val() || ''
								}
							}
						);

						this.addToForm(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'col-xs-12' )
							.appendTo(
								new ui.base.BaseHTMLElement( 'div' )
									.addClass( 'form-group clearfix' )
								.appendTo( _basicLeft )
							),
							this.m_Form,
							basic_ind
						);

						this.addToForm(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'col-xs-12' )
							.appendTo(
								new ui.base.BaseHTMLElement( 'div' )
									.addClass( 'form-group clearfix' )
								.appendTo( _basicRight )
							),
							this.m_Form,
							basic_ann
						);
					}
					// #endregion basic

					// #region modernize
					{
						const _mod = new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12' )
						.appendTo( root );

						new ui.base.BaseHTMLElement( 'h4' )
							.text( 'Verbesserungsmaßnahmen' )
							.addClass( 'text-muted' )
						.appendTo( _mod );

						this.buildLNS( _mod, this.m_Mod.redevelopment.windows, 'Fenster' );
						this.buildLNS( _mod, this.m_Mod.redevelopment.electricity, 'Leitungssysteme - Strom' );
						this.buildLNS( _mod, this.m_Mod.redevelopment.gas, 'Leitungssysteme - Gas' );
						this.buildLNS( _mod, this.m_Mod.redevelopment.water, 'Leitungssysteme - Wasser' );
						this.buildLNS( _mod, this.m_Mod.redevelopment.sewage, 'Leitungssysteme - Abwasser' );
						this.buildLNS( _mod, this.m_Mod.redevelopment.heating_system, 'Heizungsanlage' );
						this.buildLNS( _mod, this.m_Mod.redevelopment.sanitary, 'Sanitäreinrichtungen' );
						this.buildLNS( _mod, this.m_Mod.redevelopment.interior, 'Innenausbau (z.B. Decken, Fußböden, Treppen)' );

						new ui.base.BaseHTMLElement( 'h4' )
							.text( 'Erneuerungen und Einbauten' )
							.addClass( 'text-muted' )
						.appendTo( _mod );

						this.buildModBool(
							_mod,
							this.m_Mod.redevelopment.roof, 'Dacherneuerung inkl. Verbesserung der Wärmedämmung',
							'Modernisierung durchgeführt'
						);
						this.buildModBool(
							_mod,
							this.m_Mod.redevelopment.outdoor_walls, 'Wärmedämmung der Außenwände',
							'Modernisierung durchgeführt'
						);
						this.buildModBool(
							_mod,
							this.m_Mod.redevelopment.floor_plan, 'Wesentliche Verbesserung der Grundrissgestaltung',
							'Modernisierung durchgeführt'
						);
					}
					// #endregion modernize

					// #region additional
					{
						const _add = new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12' )
						.appendTo( root );
					}
					// #endregion additional
				}

				protected buildNavigation( nav: ui.base.BaseHTMLElement ): void
				{
					new ui.base.Button(
						$('<i class="fas fa-arrow-circle-left"></i> <span>Zurück</span>'),
						{
							context: 'primary',
							on:
							{
								click: () =>
								{
									if ( this.m_Panel ) { this.m_Panel.MovePrev(); }
								}
							}
						}
					).rebuild( nav );

					new ui.base.Button(
						$('<span>Weiter</span> <i class="fas fa-arrow-circle-right"></i>'),
						{
							context: 'primary',
							on:
							{
								click: () =>
								{
									if ( this.m_Panel )
									{
										if ( this.m_Obj.checkForm( this.m_Form ) )
										{
											this.m_Panel.MoveNext();
										}
									}
								}
							}
						}
					).rebuild( nav );
				}

				private buildLNS(
					_root: ui.base.BaseHTMLElement,
					entry: IModernizationDetail<number>,
					label: string
				): ILNSResult
				{
					const __root = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'form-group clearfix' )
					.appendTo( _root );

					new ui.base.BaseHTMLElement( 'label' )
						.addClass( 'control-label col-xs-3' )
						.text( label )
					.appendTo( __root );

					const c_y: ui.Form.NumberInput = new ui.Form.NumberInput(
						entry.year,
						{
							min: 0,
							max: new Date().getFullYear(),
							step: 1,
							control: true,
							on:
							{
								change: () => entry.year = c_y.val()
							}
						}
					);

					const lns: ui.Form.LabelledNumberSlider = new ui.Form.LabelledNumberSlider(
						entry.value || -1,
						{
							min: 1,
							max: 100,
							step: 25,
							control: true,
							sentinal: 'Nein',
							on:
							{
								change: () =>
								{
									entry.value = lns.val();

									if ( entry.year === null )
									{
										// ? Hier könnte ein Makler-spezifischer Default Wert verwendet werden!!!!
										c_y.value( new Date().getFullYear() - 5 );
										entry.year = new Date().getFullYear() - 5;
									}
								}
							}
						},
						( value: number ) => value + "%"
					);

					this.addToForm(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-5' )
						.appendTo( __root ),
						this.m_Form,
						lns
					);

					this.addToForm(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-3 col-md-2' )
						.appendTo( __root ),
						this.m_Form,
						c_y
					);

					return {
						slider: lns,
						cy: c_y
					};
				}

				private buildModBool(
					_root: ui.base.BaseHTMLElement,
					entry: IModerizationBool,
					label: string,
					_title: string
				): IModBoolResult
				{
					const __root = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'form-group clearfix' )
					.appendTo( _root );

					new ui.base.BaseHTMLElement( 'label' )
						.addClass( 'control-label col-xs-4' )
						.text( label )
					.appendTo( __root );

					const c_y: ui.Form.NumberInput = new ui.Form.NumberInput(
						entry.year || null,
						{
							min: 0,
							max: new Date().getFullYear(),
							step: 1,
							control: true,
							on:
							{
								change: () => entry.year = c_y.val() || 0
							}
						}
					);

					const bool: ui.Form.Checkbox = new ui.Form.Checkbox(
						{
							title: _title,
							descriptor:
							{
								on:
								{
									change: () =>
									{
										entry.value = bool.isChecked() ? 100 : 0;

										if ( entry.value && entry.year === 0 )
										{
											// ? Hier könnte ein Makler-spezifischer Default Wert verwendet werden!!!!
											entry.year = new Date().getFullYear() - 5;
											c_y.value(entry.year);
										}

										if ( !entry.value )
										{
											entry.year = 0;
											c_y.value( null );
										}
									}
								}
							}
						}
					);

					bool.value( entry.value );

					this.addToForm(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-4' )
						.appendTo( __root ),
						this.m_Form,
						bool
					);

					this.addToForm(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-3 col-md-2' )
						.appendTo( __root ),
						this.m_Form,
						c_y
					);

					return {
						done: bool,
						cy: c_y
					};
				}

			}
		}
	}
}
